export default __webpack_public_path__ + "static/media/request-render-full-macos.8af69ca0.avif";